import { Metamodel } from '../base/model';
import { IModel, IAttribute, IValidationContext, IViolation } from '../base/annotation';
import { format } from '../../shared/utils/string.util';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { ModelConstants } from '../model-constants';
import { GlobalVariables } from '../../constants/globals';
import { LinkedService } from './linkedservice';
import { validateLinkedServiceProperties } from '../../shared/utils/linkedservice-validation-util';
import { Named } from '../base/named';

@Metamodel.model({
    name: ModelConstants.sqlAnalyticsEndpointLinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.SqlAnalyticsEndpoint_DisplayText),
        format(shellStringResources.ModelName_LinkedServicesTemplate, shellStringResources.SqlAnalyticsEndpoint_DisplayText)
    ],
    validator: SqlAnalyticsEndpointLinkedService.validateSqlAnalyticsEndpointLinkedService
})
export class SqlAnalyticsEndpointLinkedService extends LinkedService {
    public static readonly MODEL: IModel;
    public static readonly ARTIFACT_ID: IAttribute;
    public static readonly ENDPOINT: IAttribute;
    public static readonly WORKSPACE_ID: IAttribute;

    public static async validateSqlAnalyticsEndpointLinkedService(
        linkedService: SqlAnalyticsEndpointLinkedService,
        context: IValidationContext
    ): Promise<IViolation[]> {
        if (GlobalVariables.isTrident) {
            return validateLinkedServiceProperties(linkedService, [
                SqlAnalyticsEndpointLinkedService.ARTIFACT_ID,
                SqlAnalyticsEndpointLinkedService.ENDPOINT
            ]);
        }
        return undefined;
    }

    public override readonly tridentArtifactType: 'SqlAnalyticsEndpoint' = GlobalVariables.isTrident ? ModelConstants.sqlAnalyticsEndpointArtifactType : undefined;

    @Metamodel.attribute({
        display: format(shellStringResources.ObjectIdLabel, shellStringResources.SqlAnalyticsEndpoint_DisplayText),
        association: 'ARTIFACT_ID',
        accepts: ['String'],
        templatable: true
    })
    public artifactId?: string;

    @Metamodel.attribute({
        display: shellStringResources.WorkspaceId,
        association: 'WORKSPACE_ID',
        accepts: ['String'],
        templatable: true
    })
    public workspaceId?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Endpoint,
        association: 'ENDPOINT',
        accepts: ['String'],
        templatable: true
    })
    public endpoint?: string;

    @Metamodel.attribute({
        reference: true
    })
    public parentEntity?: Named;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
